export const scopeThreeCategories = [
  {
    index: 1,
    numberKey: "One",
    translationKey: "purchasedGoodsAndServices",
    color: "hsl(145, 28%, 49%, 1)"
  },
  {
    index: 2,
    numberKey: "Two",
    translationKey: "capitalGoods",
    color: "hsla(7, 66%, 55%, 1)"
  },
  {
    index: 3,
    numberKey: "Three",
    translationKey: "fuelAndEnergyRelatedActivities",
    color: "hsla(295, 63%, 65%, 1)"
  },
  {
    index: 4,
    numberKey: "Four",
    translationKey: "upstreamTransportationAndDistribution",
    color: "hsla(256, 63%, 65%, 1)"
  },
  {
    index: 5,
    numberKey: "Five",
    translationKey: "wasteGeneratedInOperations",
    color: "hsla(263, 69%, 54%, 1)"
  },
  {
    index: 6,
    numberKey: "Six",
    translationKey: "businessTravel",
    color: "hsla(227, 69%, 54%, 1)"
  },
  {
    index: 7,
    numberKey: "Seven",
    translationKey: "employeeCommuting",
    color: "hsla(202, 69%, 54%, 1)"
  },
  {
    index: 8,
    numberKey: "Eight",
    translationKey: "upstreamLeasedAssets",
    color: "hsla(176, 69%, 54%, 1)"
  },
  {
    index: 9,
    numberKey: "Nine",
    translationKey: "downstreamTransportationAndDistribution",
    color: "hsl(153,70%,52%)"
  },
  {
    index: 10,
    numberKey: "Ten",
    translationKey: "processingOfSoldProducts",
    color: "hsla(69, 69%, 54%, 1)"
  },
  {
    index: 11,
    numberKey: "Eleven",
    translationKey: "useOfSoldProducts",
    color: "hsla(51, 83%, 64%, 1)"
  },
  {
    index: 12,
    numberKey: "Twelve",
    translationKey: "treatmentOfSoldProducts",
    color: "hsla(29, 83%, 64%, 1)"
  },
  {
    index: 13,
    numberKey: "Thirteen",
    translationKey: "downstreamLeasedAssets",
    color: "hsl(0,66%,40%)"
  },
  {
    index: 14,
    numberKey: "Fourteen",
    translationKey: "franchises",
    color: "hsla(51,61%,42%,0.49)"
  },
  {
    index: 15,
    numberKey: "Fifteen",
    translationKey: "investments",
    color: "hsla(0,0%,57%,0.76)"
  }
];

export const mapByDimensionReportData = (apiData) => {
  return apiData?.content?.map(el => {
    return {
      name: el.dimensionItem,
      "Scope 1": el.scopeOneTotalCo2Emissions,
      "Scope 2": el.scopeTwoTotalCo2Emissions,
      "Scope 3": el.scopeThreeTotalCo2Emissions,
      total: el.totalCo2Emissions
    };
  }) ?? [];
};

export const mapYearsData = (data, yearsKeys) => {
  return data.map(el => {
    const mappedData = {
      dimensionItem: el.dimensionItem,
      detailedData: {}
    };

    yearsKeys.forEach(year => {
      const foundItem = el.annualTotalEmissions?.find(ann => ann.year === year);
      mappedData[year] = foundItem?.totalCo2Emissions ?? 0;
      mappedData.detailedData = {
        ...mappedData.detailedData,
        [year]: {
          "scopeOneTotalCo2Emissions": foundItem?.["scopeOneTotalCo2Emissions"] ?? 0,
          "scopeTwoTotalCo2Emissions": foundItem?.["scopeTwoTotalCo2Emissions"] ?? 0
        }
      };
    });

    return mappedData;
  });
};